import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { STAGE_META, StageTone, WorkflowStage } from '../../models/campaign-workflow.model';

const TONE_CLASSES: Record<StageTone, string> = {
  neutral: 'bg-muted text-muted-foreground',
  primary: 'bg-primary/10 text-primary',
  warning: 'bg-warning-soft text-warning',
  success: 'bg-success-soft text-success',
  danger: 'bg-danger-soft text-danger',
};
/** The stage of one analysis, the same everywhere. */
@Component({
  selector: 'app-stage-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex' },
  template: `
    <span
      class="inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-md px-2 font-mono text-2xs leading-none"
      [class]="tone()"
    >
      <span class="size-1.5 shrink-0 rounded-full" [style.background-color]="meta().color" aria-hidden="true"></span>
      {{ label() ?? meta().label }}
    </span>
  `,
})
export class StageChip {
  readonly stage = input.required<WorkflowStage>();
  /** Other wording in the stage's colours, e.g. the campaign's state. */
  readonly label = input<string | null>(null);
  readonly meta = computed(() => STAGE_META[this.stage()]);
  readonly tone = computed(() => TONE_CLASSES[this.meta().tone]);
}
